<template>
    <form class="p-contact__content"
        method="post" action="business/send-mail"
        ref="form"
        @submit.stop.prevent="sendMail()"
    >
        <div class="p-contact__content__detail">
            <p>お名前<span>必須</span></p>
            <p>
                <text-input-group
                    :error="error.first('name')"
                    type="text"
                    name="name"
                    placeholder="例）田中　悠人"
                    v-model="form.params.name"
                    :required="true"
                    :resetInput="resetInput"
                />
            </p>
        </div>
        <div class="p-contact__content__detail">
            <p>お名前（よみがな）<span>必須</span></p>
            <p>
                <text-input-group
                    :error="error.first('katakana_name')"
                    type="text"
                    name="katakana_name"
                    placeholder="例）たなか　ゆうと"
                    v-model="form.params.katakana_name"
                    :required="true"
                    :resetInput="resetInput"
                />
            </p>
        </div>
        <div class="p-contact__content__detail">
            <p>会社名</p>
            <p>
                <text-input-group
                    :error="error.first('company_name')"
                    type="text"
                    name="company_name"
                    placeholder="会社名をご入力ください"
                    v-model="form.params.company_name"
                    :resetInput="resetInput"
                />
            </p>
        </div>
        <div class="p-contact__content__detail">
            <p>メールアドレス<span>必須</span></p>
            <p>
                <text-input-group
                    :error="error.first('email')"
                    type="text"
                    name="email"
                    placeholder="メールアドレスをご入力ください"
                    v-model="form.params.email"
                    :required="true"
                    :resetInput="resetInput"
                />
            </p>
        </div>
        <div class="p-contact__content__detail">
            <p>題名<span>必須</span></p>
            <p>
                <text-input-group
                    :error="error.first('title')"
                    type="text"
                    name="title"
                    placeholder="題名をご入力ください"
                    v-model="form.params.title"
                    :required="true"
                    :resetInput="resetInput"
                />
            </p>
        </div>
        <div class="p-contact__content__detail">
            <p>お問合せ内容<span>必須</span></p>
            <p>
                <text-area-group
                    v-model="form.params.contact"
                    :error="error.first('contact')"
                    type="text"
                    placeholder="お問合せ内容をご入力ください"
                    name="description"
                    :rows="10"
                    :resetInput="resetInput"
                    @focus="handleEvent"
                />
            </p>
        </div>
        <div class="p-contact__content__text">
            【個人情報の取り扱い】<br />
            個人情報保護管理者兼お問い合わせ窓口 ： <br />
            &emsp; 株式会社コミットグロース<br />
            &emsp; 東京都千代田区神田司町2-2-5 DK・Tビル6階<br />
            &emsp; 濱潟 好古　TEL：03-6262-9800<br />
            利用目的：お客様からご提供頂いた個人情報は、お問い合わせの内容確認および回答を行うために使用致します。<br />
            委託について：当ページで取得する個人情報の取り扱いの一部を外部に委託することがあります。<br />
            任意性：お客様がご提供頂ける個人情報はお客様の任意です。但し必要な項目をご提供頂けない場合は利用目的を達成できないことがあります。<br />
            開示などのお問い合わせ：利用目的の通知、開示、訂正、利用停止などのお問い合わせは<a
                href="/contact"
                >こちら</a
            >から
        </div>
        <div class="p-contact__content__detail">
            <label>
                <input type="checkbox" ref="confirmChecked" v-model="checked"/>
                <span
                    >【個人情報の取り扱い】に同意の上、上記の内容でよろしければ、チェックを入れてください。</span
                >
            </label>
        </div>
        <div class="p-contact__content__submit"
            :class="{ 'active': (!checked | isDiabled) }"
        >
            <input type="submit" value="送信" :disabled="!checked">
        </div>
    </form>
</template>
<script>
import Errors from "@/utils/Errors"
import Form from "@/utils/Form"
import TextInputGroup from '@/shared/Input/TextInputGroup'
import TextAreaGroup from '@/shared/Input/TextAreaGroup'
export default ({
    components: {
        TextInputGroup,
        TextAreaGroup,
    },

    props: {
        data: {
            type: Array | Object | null,
            default: null,
            required: false,
        },
        errors: {
            type: Array | Object | null,
            default: null,
            required: false,
        },
    },

    data() {
        return {
            error: new Errors(this.errors ? this.errors : []),
            form: new Form(this.data && this.data.length > 0 ? this.data : {
                contact: '',
                email: '',
                company_name: '',
                katakana_name: '',
                name: '',
                title: '',
            }),
            checked: false,
            message: '',
            isDiabled: false,
            windowTop: 0,
            resetInput: false
        }
    },

    mounted() {
        this.getPosition()
    },

    methods: {
        sendMail() {
            this.isDiabled = true
            this.form
                .post({
                    url: "contact/send-mail",
                })
                .then( (res) => {
                    this.isDiabled = false
                    this.checked = true
                    flash(res.data.message, 'success')
                    this.resetInput = true
                    this.resetForm()
                    this.toScroll()
                })
                .catch( () => {
                    this.error = this.form.errors
                    this.isDiabled = false
                })
        },
        toScroll() {
            window.scrollTo(0, 0)
        },
        getPosition() {
            this.windowTop = this.$refs['form'].getBoundingClientRect().y
            console.log(this.windowTop)
        },

        resetForm() {
            Object.keys(this.form.params).forEach( (key,index) => {
                this.form.params[key] = '';
            });
        },
        handleEvent(e) {
            this.resetInput = e
            this.value = ''
        }
    }
})
</script>
<style scoped>
    .p-contact__content__submit.active {
        background-color: #6c757d;
        pointer-events: none;
    }
</style>
